export const eventParticipantStatuses = [
  'present',
  'absent',
  'tentative',
  'late',
  'unknown',
  'standby',
  'missing',
  'removed',
] as const

export const unavailableParticipantStatuses: EventParticipantStatus[] = [
  'absent',
  'missing',
  'removed',
]

export const presentParticipantStatuses: EventParticipantStatus[] = [
  'present',
  'standby',
]

type EventParticipantStatus = typeof eventParticipantStatuses[number]
export default EventParticipantStatus
